import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import ViewBookmark from "../View";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import { MyBookmarkTitle } from "../../../../constants";
import DataList from "./common/dataList";

// This component displays the user's bookmarked items with a toggleable grid or list view.
const MyBookmark = () => {
  const { gridView } = useAppSelector((state) => state.bookmarkTab);
  return (
    <TabPane tabId="4">
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <h4 className="mb-0">{MyBookmarkTitle}</h4>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <div className={`details-bookmark text-center ${gridView ? "" : "list-bookmark"}`}>
            <DataList />
          </div>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default MyBookmark;
